<dx-select-box [showClearButton]="!required"
               [dataSource]="dataSource"
               [grouped]="false"
               [(value)]="zone"
               [disabled]="disabled"
               fieldTemplate="field"
               placeholder="Select zone..."
               (valueChange)="zoneChange.emit($event)"
               [isValid]="!required || !!zone">
    <div *dxTemplate="let zone of 'item'">
        <adapt-zone-label [zone]="zone"></adapt-zone-label>
    </div>
    <div *dxTemplate="let zone of 'field'"
         class="h-100">
        @if (!!zone) {
            <div class="zone-label-field-template h-100 d-flex">
                <adapt-zone-label [zone]="zone"></adapt-zone-label>
                <dx-text-box class="d-none"
                             value="hidden element required by dxTemplate"
                             [readOnly]="true"></dx-text-box>
            </div>
        } @else {
            <dx-text-box value=""
                         placeholder="Select zone..."
                         [readOnly]="true"></dx-text-box>
        }
    </div>
</dx-select-box>
